<template>
  <div>
    <input type="hidden"
           value="格米尼网络科技有限公司开发" />
    <GlobalFooter class="i-copyright"
                  :links="links"
                  :copyright="copyright" />
  </div>
</template>
<script>
/* eslint-disable */
export default {
  name: 'i-copyright',
  data () {
    return {
      links: [
        // {
        //   title: '官网',
        //   key: '官网',
        //   href: 'http://gemini-galaxy.com',
        //   blankTarget: true
        // },
        // {
        //   title: '社区',
        //   key: '社区',
        //   href: 'http://gemini-galaxy.com',
        //   blankTarget: true
        // },
        // {
        //   title: '商城',
        //   key: '商城',
        //   href: 'http://mall.gemini-galaxy.com',
        //   blankTarget: true
        // }
      ],
      //  copyright: 'Copyright © 2017-2020 格米尼网络科技'
      copyright: 'developer gemini-galaxy.com'
    }
  }
}
</script>
<style lang="less">
.i-copyright {
  flex: 0 0 auto;
}
</style>
